import { BarChartBig, Calculator, Headset, Mail, MapPin, MessageCircle, Settings } from "lucide-react-native";
import { subNavigationCollectionType } from "types/navigation.types";

const navigationCollection = [
	{ title: "Home", href: "/" },
	{ title: "My Sites", href: "/sites" },
	{ title: "Orders", href: "/orders" },
	{ title: "Products", href: "/products" },
	{ title: "Equipment", href: "/equipment" }
];

const navigationCollectionPublic = [ 
	{ title: "About Us", href: "/about-us" },
	{ title: "Products", href: "/products" },
	{ title: "Equipment", href: "/equipment" },
	{ title: "Services", href: "/services" },
	{ title: "Sustainability", href: "/sustainability" },
	{ title: "Articles", href: "/articles" },
];

const subNavigationCollection = [
	// { title: "Support", href: "/support", icon: MessageCircle },
	{ title: "Finance & Accounts", href: "/finance", icon: Calculator },
	{ title: "Reports", href: "/reports", icon: BarChartBig },
	{ title: "Admin", href: "/admin", icon: Settings },
];

const subNavigationCollectionPublic: subNavigationCollectionType = [
	{
		title: "Locations",
		href: "/locations",
		icon: MapPin,
	},
	{
		title: "Contact",
		href: "/contact",
		icon: Mail,
	},
];

export { navigationCollection, navigationCollectionPublic, subNavigationCollection, subNavigationCollectionPublic };
